import React, { useContext } from 'react'
import { TypeAlert } from './type-alert'
import { TypeToast } from './type-toast'
import { TypeModal } from './type-modal'
import { itemType } from './hooks'
import { useReducerList } from '../../shared/hooks/reducer-list'
import { markShown, noticeClose, noticeParts } from '../../shared/error/error-notice'

const NotificationContext = React.createContext()

export const useNotificationContext = () => {
  return useContext(NotificationContext)
}

export const NotificationItems = () => {
  const notificationContext = useContext(NotificationContext)

  return (
    <React.Fragment>
      <TypeAlert state={notificationContext.state.alertState} onClose={notificationContext.state.alertRemoveID} />
      <TypeToast state={notificationContext.state.toastState} onClose={notificationContext.state.toastRemoveID} />
      <TypeModal state={notificationContext.state.modalState} onClose={notificationContext.state.modalRemoveID} />
    </React.Fragment>
  )
}

// An item whose text is an API error (or withReference's pair) marks the
// error as shown, so a Form it is rethrown to doesn't show it again.
const shown = addItem => (item, close) => {
  markShown(noticeParts(item.text).error)
  return addItem(item, close)
}

export const NotificationProvider = ({ children }) => {
  const [alertState, alertAdd, alertRemoveID, alertRemoveAll] = useReducerList()
  const [toastState, toastAdd, toastRemoveID, toastRemoveAll] = useReducerList()
  const [modalState, modalAdd, modalRemoveID, modalRemoveAll] = useReducerList()

  const alertAddItem = shown(alertAdd)
  const toastAddItem = shown(toastAdd)
  const modalAddItem = shown(modalAdd)

  return (
    <NotificationContext.Provider
      value={{
        state: {
          alertState,
          alertRemoveID,
          toastState,
          toastRemoveID,
          modalState,
          modalRemoveID
        },

        alert: {
          notify: (text, close) => alertAddItem({ type: itemType.NOTIFY, text: text }, noticeClose(text, close)),
          warning: (text, close) => alertAddItem({ type: itemType.WARNING, text: text }, noticeClose(text, close)),
          error: (text, close) => alertAddItem({ type: itemType.ERROR, text: text }, noticeClose(text, close)),
          removeID: id => alertRemoveID(id),
          removeAll: () => alertRemoveAll()
        },
        toast: {
          notify: (text, close) => toastAddItem({ type: itemType.NOTIFY, text: text }, noticeClose(text, close)),
          warning: (text, close) => toastAddItem({ type: itemType.WARNING, text: text }, noticeClose(text, close)),
          error: (text, close) => toastAddItem({ type: itemType.ERROR, text: text }, noticeClose(text, close)),
          removeID: id => toastRemoveID(id),
          removeAll: () => toastRemoveAll()
        },
        modal: {
          notify: (text, close) => modalAddItem({ type: itemType.NOTIFY, text: text }, noticeClose(text, close)),
          warning: (text, close) => modalAddItem({ type: itemType.WARNING, text: text }, noticeClose(text, close)),
          error: (text, close) => modalAddItem({ type: itemType.ERROR, text: text }, noticeClose(text, close)),
          removeID: id => modalRemoveID(id),
          removeAll: () => modalRemoveAll()
        }
      }}>
      <NotificationItems />
      {children}
    </NotificationContext.Provider>
  )
}
